<template>
  <el-button
    v-bind="$attrs"
    type="text"
    :size="size"
    :title="title"
    :class="['bdc-icon-refresh-btn', customClass]"
    v-on="$listeners"
  >
    <svg-icon icon-class="bdc-btn-refresh" class="bdc-icon-refresh-btn__icon" />
  </el-button>
</template>

<script>
export default {
  name: 'BdcRefreshButton',
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: 'mini'
    },
    title: {
      type: String,
      default: '刷新'
    },
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>
